import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThisMonth from '../../components/dashboard/ThisMonth';
import {
  getCasesRestoration,
  getCasesStatus,
  getCasesActivity,
} from '../../modules/dashboard';
import { useTranslation } from 'react-i18next';
import { setFilters } from '../../modules/cases';

import styled from 'styled-components';
import { useRefreshOnAuthError, useAutoRefreshEvent } from '../../lib/common';

import ActivityList from '../../components/dashboard/ActivityList';
import CasesStatus from '../../components/dashboard/CasesStatus';
import InputSelect from '../../components/common/InputSelect';
import Spinner from '../../components/common/Spinner';
import MessageBox from '../../components/common/MessageBox';
import Cookies from 'universal-cookie';
import { getEventsToken } from '../../lib/api/auth';
import QRCodeScanner from '../../components/auth/styled/QRCodeScanner';
import client from '../../lib/api/client';
import GPUDetectionModal from '../../components/common/GPUDetectionModal';
import useGeoLocation from '../../lib/useGeoLocation';
import { skin_name, odm_name } from '../../lib/odm';

const DashboardLayout = styled.div`
  display: grid;
  width: auto;
  height: 100%;
  max-width: ${(props) => props.maxWidth}; // 1184px;
  min-width: 1036px;

  grid-template-columns: 40px 1fr 40px;
  grid-template-rows: 64px 32px 16px 272px 64px 1fr 64px;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    '. TopMargin RightMargin'
    '. DashboardTitle RightMargin'
    '. . RightMargin'
    '. CaseStatus-ThisMonth .'
    '. . .'
    '. Activity-AskSupport .'
    '. . .';

  .RightMargin {
    grid-area: RightMargin;
  }
  .TopMargin {
    grid-area: TopMargin;
  }
  .DashboardTitle {
    margin-left: 8px;
    font-family: Source Sans Pro;
    font-size: 25px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #59616a;
    grid-area: DashboardTitle;
  }

  .CaseStatus-ThisMonth {
    display: grid;
    grid-template-columns: 842fr 262fr;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas: 'CaseStatus ThisMonth';
    grid-area: CaseStatus-ThisMonth;
  }

  .CaseStatus {
    grid-area: CaseStatus;
  }
  .ThisMonth {
    min-width: 262px;
    max-width: 309px;
    grid-area: ThisMonth;
  }

  .Activity-AskSupport {
    display: grid;
    grid-template-columns: 729fr 21px 353fr;
    //grid-template-columns: 3fr 1fr;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas: 'Activity Space5 AskSupportArea';
    grid-area: Activity-AskSupport;
  }

  .Activity {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 40px 8px 1fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas:
      'ActivityTitle-DayFilter ActivityTitle-DayFilter'
      'Space4 Space4'
      'ActivityList ActivityList';
    grid-area: Activity;
  }

  .ActivityTitle-DayFilter {
    display: grid;
    grid-template-columns: 1fr 167px;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas: 'ActivityTitle DayFilter';
    grid-area: ActivityTitle-DayFilter;
  }

  .Space4 {
    grid-area: Space4;
  }

  .ActivityTitle {
    margin-left: 8px;
    font-family: Source Sans Pro;
    font-size: 25px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #59616a;
    grid-area: ActivityTitle;
  }

  .DayFilter {
    margin-right: 21px;
    grid-area: DayFilter;
  }

  .ActivityList {
    grid-area: ActivityList;
  }

  .Download3DiscLab {
    height: 72px;
    border-radius: 4px;
    background-color: #f5f6f6;
    cursor: pointer;

    position: relative;
    overflow: hidden;
  }

  .Download3DiscLab .downloadBannerImg {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: auto;
    object-fit: contain;
    display: block;
    pointer-events: none;
  }

  .Download3DiscLab .AskSupportTitle {
    position: absolute;
    z-index: 1;
    padding-right: 140px;
  }

  .Documentation3Disc {
    cursor: pointer;
    height: 72px;
    background-color: #f5f6f6;
    border-radius: 4px;
    position: relative;
  }

  .Documentation3DiscTitle {
    position: absolute;
    width: 300px;
    margin-left: 20px;
    font-family: Source Sans Pro;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-overflow: ellipsis;
    color: #59616a;
  }

  .AskSupportArea {
    margin-top: 48px;
    background-color: transparent;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    position: relative;
    gap: 11px;
    grid-area: AskSupportArea;
  }

  .AskSupport {
    position: relative;
    height: 150px;
    background-color: #f5f6f6;
    border-radius: 4px;
  }

  .AskSupport a {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-decoration: none;
  }

  .AskSupportTitle {
    position: absolute;
    width: 300px;
    /* height: 100px; */
    margin-left: 20px;
    margin-top: 20px;
    font-family: Source Sans Pro;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-overflow: ellipsis;
    color: #59616a;
  }

  .AskSupportDesc {
    position: absolute;
    width: 210px;
    /* height: 100px; */
    margin-left: 20px;
    margin-top: 70px;
    font-family: Source Sans Pro;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #59616a;
  }

  .AskTitle {
    position: absolute;
    top: -44px;
    font-family: Source Sans Pro;
    font-size: 25px;
    font-weight: 600;
    font-stretch: normal;
    font-style;
    line-height: normal;
    letter-spacing: normal;
    color: #59616a;
  }
`;

const LoadMoreButton = styled.button`
  display: block;
  width: auto;
  min-width: 95px;
  padding-left: 10px;
  padding-right: 10px;
  height: 40px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 32px;
  border-radius: 4px;
  border: solid 1px #e7e9ea;
  background-color: #ffffff;
  cursor: pointer;
  &:hover {
    background-color: #f5f6f6;
  }
  &:active {
    border: solid 1px ${(props) => props.theme.main_color};
    background-color: ${(props) => props.theme.main_color_focus};
  }

  .Text {
    font-family: Source Sans Pro;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.2px;
    text-align: center;
    color: ${(props) => props.theme.main_color};
  }
`;

const ErrorLoadingBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.height || '160px'};

  font-family: Source Sans Pro;
  font-size: 15px;
  color: #59616a;
`;

const getRequestErrorMessage = (error, fallback) => {
  if (!error) return null;

  const responseData = error.response && error.response.data;
  if (typeof responseData === 'string') return responseData;
  if (responseData && typeof responseData.detail === 'string') {
    return responseData.detail;
  }
  if (responseData && typeof responseData.message === 'string') {
    return responseData.message;
  }
  if (typeof error.message === 'string') return error.message;
  if (typeof error === 'string') return error;

  return fallback;
};

const DashboardContainer = (props) => {
  const dispatch = useDispatch();

  const {
    filter,
    user_checking,
    casesStatus,
    casesRestorations,
    casesActivities,
    error_status,
    error_resto,
    error_activity,
    loading_resto,
    loading_activity,
    user,
    odm,
    app,
  } = useSelector(({ cases, dashboard, loading, leftpanel, user, app }) => ({
    filter: cases.filters,
    user_checking: loading['user/CHECK'],
    loading_status: loading['dashboard/CASESSTATUS'],
    casesStatus: dashboard.casesStatus,
    loading_resto: loading['dashboard/CASESRESTORATION'],
    casesRestorations: dashboard.casesRestorations,
    loading_activity: loading['dashboard/CASESACTIVITY'],
    casesActivities: dashboard.casesActivities,
    error_status: dashboard.error_status,
    error_resto: dashboard.error_resto,
    error_activity: dashboard.error_activity,
    collapsed: leftpanel.collapsed,
    user: user.user,
    userSettings: user.settings,
    odm: app.odm,
    app: app.app,
  }));

  const { t } = useTranslation();
  const dashboardErrorFallback = t('Unable to load dashboard data');
  const errorStatusMessage = getRequestErrorMessage(
    error_status,
    dashboardErrorFallback,
  );
  const errorRestorationMessage = getRequestErrorMessage(
    error_resto,
    dashboardErrorFallback,
  );
  const errorActivityMessage = getRequestErrorMessage(
    error_activity,
    dashboardErrorFallback,
  );
  const [showFirstLoginModal, setShowFirstLoginModal] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [firstLoginHandled, setFirstLoginHandled] = useState(false);
  const downloadTileRef = useRef(null);
  const [showGPUModal, setShowGPUModal] = useState(false);

  const is3DiscCloudOrQuantorshare =
    (odm_name === 'HCLOUD' && skin_name === '3disccloud') ||
    (odm_name === 'HCLOUD' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1'));

  const isEzscan = odm_name === 'EZSCAN';

  const dashboardBannerImg = isEzscan
    ? process.env.PUBLIC_URL +
      '/images/odm/EZSCAN/dashboard/bg-3disclab-banner-ezscan.svg'
    : process.env.PUBLIC_URL + '/images/dashboard/bg-3disclab-banner.svg';

  const SW_VERSION_URL =
    'https://updatewithjson.s3.eu-central-1.amazonaws.com/sw_version.json';

  const getJsonKey = () => {
    if (odm_name === 'EZSCAN') return 'Vatech';
    if (odm_name === 'IMESICORE') return 'imes-icore';
    if (odm_name === 'GRO3X') return 'Gro3X';
    if (odm_name === 'WHIPMIX') return 'Whip Mix';
    return '3Disc';
  };

  const directDownloadOVO = async () => {
    try {
      const response = await fetch(SW_VERSION_URL);
      const data = await response.json();
      const jsonKey = getJsonKey();

      console.log('Direct download for', jsonKey, 'JSON data:', data);

      const entry = data[jsonKey];
      if (entry?.OVO?.Link) {
        // console.log('Download URL for', jsonKey, '/OVO:', entry.OVO.Link);
        window.open(entry.OVO.Link, '_blank');
      } else {
        // console.error('No download URL found for', jsonKey, '- entry:', entry);
        alert(t('Download link not available. Please try again later.'));
      }
    } catch (error) {
      console.error('Failed to fetch download link:', error);
      // alert(t('Failed to fetch download link. Please try again later.'));
    }
  };

  const { countryCode: geoCountryCode, loading: geoLoading } = useGeoLocation();

  const isBlockedCountry = (code) => {
    if (!code) return false;
    const c = String(code).trim().toUpperCase();
    return c === 'ES' || c === 'PT' || c === 'SPAIN' || c === 'PORTUGAL';
  };

  const isSpainOrPortugal =
    isBlockedCountry(geoCountryCode) || isBlockedCountry(user?.country);

  const getAutoOpenDownloadSoftwareKey = (u) => {
    const uid = u?.idb64 || u?.id || u?.username || 'anon';
    return `autoOpenDownloadSoftware:${uid}`;
  };

  useEffect(() => {
    if (user_checking) return;
    if (!user) return;

    if (user.inst_type_guessed !== 'Clinic') return;
    if (geoLoading) return;
    if (isSpainOrPortugal) return;

    if (!is3DiscCloudOrQuantorshare) return;

    if (user.is_first_login !== true) return;

    const key = getAutoOpenDownloadSoftwareKey(user);
    if (localStorage.getItem(key) === '1') return;
    localStorage.setItem(key, '1');

    setShowGPUModal(true);
  }, [user_checking, user, geoLoading, isSpainOrPortugal, is3DiscCloudOrQuantorshare]);

  const getDownloadCoachKey = (u) => {
    const uid = u?.idb64 || u?.id || u?.username || 'anon';
    return `downloadCoachShownCount:${uid}`;
  };

  useEffect(() => {
    if (user_checking) return;
    if (!user) return;
    if (!is3DiscCloudOrQuantorshare) return;
    if (user.inst_type_guessed !== 'Clinic') return;
    if (geoLoading) return;
    if (isSpainOrPortugal) return;

    const key = getDownloadCoachKey(user);
    const sessionKey = `${key}:session`;

    const shownCount = Number(localStorage.getItem(key) || '0');
    const alreadyHandledThisSession = sessionStorage.getItem(sessionKey) === '1';

    if (shownCount >= 3) {
      return;
    }
    if (alreadyHandledThisSession) return;

    sessionStorage.setItem(sessionKey, '1');
    localStorage.setItem(key, String(shownCount + 1));

    const timeoutId = setTimeout(() => {
      downloadTileRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [user_checking, user, geoLoading, isSpainOrPortugal, is3DiscCloudOrQuantorshare]);

  // const closeDownloadCoach = () => {
  //   setShowDownloadCoach(false);
  // };

  useEffect(() => {
    try {
      const uStr = localStorage.getItem('user');
      if (uStr) {
        const u = JSON.parse(uStr);
        if (u.is_first_login === false) setFirstLoginHandled(true);
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (firstLoginHandled) return;
  }, [user, user_checking, odm, firstLoginHandled]);

  const download3DiscLab = t('Download 3DiscLab');
  const index = download3DiscLab.indexOf(t('3Disc'));

  const [loadedPageNum, setLoadedPageNum] = useState(1);
  const [actUsers, setActUsers] = useState([]);
  const [actList, setActList] = useState([]);
  const [actPeriod, setActPeriod] = useState('thisweek');
  const [restoPeriod, setRestoPeriod] = useState('thisweek');
  const [requestActivity, setRequestActivity] = useState(false);
  const telnumber = odm.company_name === 'vatech' ? '244 - 2076' : '570 – 0363';

  const [lastSelectedAct, setLastSelectedAct] = useState(t('Work week'));

  //MessageBox
  const [messageTitle, setMessageTitle] = useState('');
  const [messageType, setMessageType] = useState('ok');
  const [messageVisible, setMessageVisible] = useState(false);
  const [messageContent, setMessageContent] = useState('');

  var selectedAct = 'Work week';
  var selectedResto = 'Work week';

  const event = useAutoRefreshEvent();

  const handleDeviceRegistered = async () => {
    try {
      await client.post('/v1/auth/set-first-login-viewed/').catch(() => {});
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const u = JSON.parse(userStr);
        u.is_first_login = false;
        localStorage.setItem('user', JSON.stringify(u));
      }
    } catch (e) {
    } finally {
      setFirstLoginHandled(true);
      setShowScanner(false);
      setShowFirstLoginModal(false);
    }
  };

  const onConfirmBoxOk = (e, callback) => {
    callback();
    setMessageVisible(false);
  };

  const onCancel = () => {
    setMessageVisible(false);
  };

  const getCookies = (name) => {
    const cookies = new Cookies();
    const cookie = cookies.get(name);
    return cookie;
  };

  const onClickDownload3DiscLab = async () => {
    if (user?.inst_type_guessed !== 'Lab') return;

    try {
      const response = await fetch(SW_VERSION_URL);
      const data = await response.json();
      const jsonKey = getJsonKey();

      console.log('Download 3DiscLab for', jsonKey, 'JSON data:', data);

      const entry = data[jsonKey];

      const labKey = Object.keys(entry || {}).find(
        (k) => k.toLowerCase() === '3disclab',
      );

      if (labKey && entry[labKey]?.Link) {
        window.open(entry[labKey].Link, '_blank');
      } else {
        console.error(
          'No 3DiscLab download URL found for',
          jsonKey,
          '- keys:',
          Object.keys(entry || {}),
        );
        alert(t('Download link not available. Please try again later.'));
      }
    } catch (e) {
      console.error('Failed to fetch 3DiscLab download link:', e);
      alert(t('Failed to fetch download link. Please try again later.'));
    }
  };

  useEffect(() => {
    if (!user_checking && user.inst_type_guessed === 'Lab' && app.server_loc === 'EU') {
      if (!getCookies('hide')) {
        setMessageContent(
          t(
            'For labs with customers in Europe note that until Clinics/Doctors you are working with have updated their region/country please continue to check the US and EU pages to see all cases that have been sent',
          ),
        );
        setMessageTitle(t('Info'));
        setMessageType('ok');
        setMessageVisible(true);
      }
    }
  }, [user_checking]);

  useEffect(() => {
    if (event) {
      const msg = JSON.parse(event);
      if (!window.actionIDs.has(msg.action_id)) {
        if (
          msg.id === 'post_published' ||
          msg.id === 'post_uploaded' ||
          msg.id === 'post_modified' ||
          msg.id === 'post_status_modified' ||
          msg.id === 'posts_deleted' ||
          msg.id === 'files_uploaded' ||
          msg.id === 'file_deleted' ||
          msg.id === 'comment_added' ||
          msg.id === 'comment_modified' ||
          msg.id === 'comment_deleted'
        ) {
          setActUsers([]);
          setActList([]);
          if (msg.id === 'post_published' || msg.id === 'post_status_modified')
            dispatch(getCasesStatus());
          dispatch(getCasesActivity({ period: actPeriod }));
          setRequestActivity(true);
        }
      }
    }
  }, [event]);

  useEffect(() => {
    if (!user_checking) {
      dispatch(getCasesStatus());
    }
  }, [user_checking]);

  useEffect(() => {
    if (!user_checking) {
      dispatch(getCasesActivity({ period: actPeriod, page: loadedPageNum }));
      setRequestActivity(true);
    }
  }, [user_checking, loadedPageNum, actPeriod]);

  useEffect(() => {
    if (!user_checking) {
      dispatch(getCasesRestoration({ period: restoPeriod }));
    }
  }, [user_checking, restoPeriod]);

  function onLoadMore() {
    setLoadedPageNum(loadedPageNum + 1);
  }

  function onActivityFilter(item) {
    selectedAct = item;
    setLastSelectedAct(item);

    if (item === t('Work week')) setActPeriod('thisweek');
    else if (item === t('Last 7 days')) setActPeriod('week');
    else if (item === t('Work month')) setActPeriod('thismonth');
    else if (item === t('Last 30 days')) setActPeriod('month');

    setActList([]);
    setActUsers([]);
    setLoadedPageNum(1);

    if (lastSelectedAct === item) {
      dispatch(getCasesActivity({ period: actPeriod, page: loadedPageNum }));
      setRequestActivity(true);
    }
  }

  function onRestorationFilterChanged(item) {
    selectedResto = item;
    if (item === t('Work week')) setRestoPeriod('thisweek');
    else if (item === t('Last 7 days')) setRestoPeriod('week');
    else if (item === t('Work month')) setRestoPeriod('thismonth');
    else if (item === t('Last 30 days')) setRestoPeriod('month');
  }

  function statusCardClicked(id) {
    filter.status = [id];
    filter.searchString = '';
    dispatch(setFilters(filter));
  }

  function findSame(arr, c_arr) {
    return (
      arr.find((x) => {
        return c_arr.find((el) => {
          return el.action_date === x.action_date;
        });
      }) !== undefined
    );
  }

  if (requestActivity && !loading_activity && casesActivities) {
    if (
      casesActivities.users.length &&
      findSame(casesActivities.users, actUsers) === false
    ) {
      setActUsers(actUsers.concat(casesActivities.users));
    }

    if (
      casesActivities.cases_actions.length &&
      findSame(casesActivities.cases_actions, actList) === false
    ) {
      setActList(actList.concat(casesActivities.cases_actions));
    }

    setRequestActivity(false);
  }

  useRefreshOnAuthError();

  return (
    <>
      <DashboardLayout maxWidth={props.collapsed ? '1376px' : '1184px'}>
        <div className="DashboardTitle"> {t('Dashboard')} </div>
        <div className="CaseStatus-ThisMonth">
          <div className="CaseStatus">
            {errorStatusMessage ? (
              <>
                <ErrorLoadingBlock>{errorStatusMessage}</ErrorLoadingBlock>
              </>
            ) : (
              <>
                {!casesStatus ? (
                  <ErrorLoadingBlock>
                    <Spinner />
                  </ErrorLoadingBlock>
                ) : (
                  <CasesStatus status={casesStatus} clicked={statusCardClicked} />
                )}
              </>
            )}
          </div>
          <div className="ThisMonth">
            {errorRestorationMessage ? (
              <>
                <ErrorLoadingBlock>{errorRestorationMessage}</ErrorLoadingBlock>
              </>
            ) : (
              <>
                {!casesRestorations ? (
                  <ErrorLoadingBlock>
                    <Spinner />
                  </ErrorLoadingBlock>
                ) : (
                  <ThisMonth
                    restos={casesRestorations.restoration_counts}
                    onFilterChanged={onRestorationFilterChanged}
                    period={selectedResto}
                    loading={loading_resto}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <div className="Activity-AskSupport">
          <div className="Acitivity">
            <div className="ActivityTitle-DayFilter">
              <div className="ActivityTitle">{t('Activity')}</div>
              <div className="DayFilter">
                <InputSelect
                  items={[
                    t('Work week'),
                    t('Last 7 days'),
                    t('Work month'),
                    t('Last 30 days'),
                  ]}
                  onSelect={onActivityFilter}
                  placeholder=""
                  width="167px"
                  height="40px"
                  selItem={selectedAct}
                  reset="0"
                />
              </div>
            </div>
            <div className="Space4" />
            <div className="ActivityList">
              {errorActivityMessage ? (
                <>
                  <ErrorLoadingBlock>{errorActivityMessage}</ErrorLoadingBlock>
                </>
              ) : (
                <>
                  {!casesActivities ? (
                    <ErrorLoadingBlock>
                      <Spinner />
                    </ErrorLoadingBlock>
                  ) : (
                    <>
                      {loading_activity === false && actList.length == 0 ? (
                        <>
                          <ErrorLoadingBlock>{t('No activity yet')}</ErrorLoadingBlock>
                        </>
                      ) : (
                        <>
                          {loading_activity ? (
                            <ErrorLoadingBlock>
                              <Spinner />
                            </ErrorLoadingBlock>
                          ) : (
                            <>
                              <ActivityList list={actList} users={actUsers} />
                              {casesActivities.num_pages > loadedPageNum && (
                                <LoadMoreButton
                                  type="button"
                                  onClick={(e) => onLoadMore()}
                                >
                                  <div className="Text">
                                    {' '}
                                    {t('Load More').toUpperCase()}{' '}
                                  </div>
                                </LoadMoreButton>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Section "Can we help you?" - Only for 3DiscCloud/Quantorshare/localhost and EZSCAN */}
          {(is3DiscCloudOrQuantorshare || isEzscan) && (
            <div className="AskSupportArea">
              <div className="AskTitle">{t('Can we help you?')}</div>

              {/* Download Clinic tile - for 3DiscCloud clinics AND EZSCAN clinics */}
              {(is3DiscCloudOrQuantorshare || isEzscan) &&
                user.inst_type_guessed !== 'Lab' &&
                !isSpainOrPortugal && (
                  <div
                    ref={downloadTileRef}
                    className="Download3DiscLab"
                    onClick={(e) => {
                      e.preventDefault();
                      if (odm_name === 'HCLOUD') {
                        setShowGPUModal(true);
                      } else {
                        directDownloadOVO();
                      }
                    }}
                  >
                    <img
                      className="downloadBannerImg"
                      src={dashboardBannerImg}
                      alt=""
                    />

                    <div className="AskSupportTitle">
                      {isEzscan ? (
                        <>
                          {'Download '}
                          <span style={{ color: odm?.main_color || '#af212a' }}>
                            {'EzScan'}
                          </span>
                        </>
                      ) : (
                        <>
                          {'Download '}
                          <span style={{ color: '#FF6D22' }}>{'3Disc'}</span>
                          {'Clinic'}
                        </>
                      )}
                    </div>
                  </div>
                )}

              {/* Download 3DiscLab tile - ONLY for 3DiscCloud labs, NOT for EZSCAN */}
              {is3DiscCloudOrQuantorshare &&
                !isEzscan &&
                user.inst_type_guessed === 'Lab' && (
                  <div
                    className="Download3DiscLab"
                    onClick={(e) => {
                      e.preventDefault();
                      onClickDownload3DiscLab();
                    }}
                  >
                    <img
                      className="downloadBannerImg"
                      src={dashboardBannerImg}
                      alt=""
                    />

                    <div className="AskSupportTitle">
                      {download3DiscLab.substring(0, index)}
                      <span style={{ color: '#FF6D22' }}>{t('3Disc')}</span>
                      {download3DiscLab.substring(index + t('3Disc').length)}
                    </div>
                  </div>
                )}

              {/* Documentation tile - ONLY for 3DiscCloud, NOT for EZSCAN */}
              {is3DiscCloudOrQuantorshare && !isEzscan && (
                <div className="Documentation3Disc">
                  <a
                    href={
                      user.inst_type_guessed !== 'Clinic'
                        ? 'https://help.3disc.com/knowledge'
                        : 'https://help.3disc.com/knowledge'
                    }
                    target="_blank"
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL + '/images/dashboard/help3disccloud.svg'
                      }
                      style={{
                        float: 'right',
                        width: '100%',
                        height: '100%',
                      }}
                    ></img>

                    <div className="Documentation3DiscTitle">
                      {user.inst_type_guessed !== 'Clinic' ? (
                        <div style={{ marginTop: '9px' }}>
                          How to use <span style={{ color: '#FF6D22' }}>3Disc</span>
                          Cloud
                          <br /> for Labs
                        </div>
                      ) : (
                        <div style={{ marginTop: '9px' }}>
                          How to use <span style={{ color: '#FF6D22' }}>3Disc</span>
                          Cloud
                          <br /> for Dental Clinics
                        </div>
                      )}
                    </div>
                  </a>
                </div>
              )}

              {/* Ask Support tile - ONLY for 3DiscCloud, NOT for EZSCAN */}
              {is3DiscCloudOrQuantorshare && !isEzscan && (
                <div className="AskSupport">
                  <a href="https://3disc.com/contact/?s=4" target="_blank">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        '/images/dashboard/AskSupport_Image.svg'
                      }
                      style={{ float: 'right' }}
                    ></img>

                    <div className="AskSupportTitle">{t('Ask Support')}</div>
                    <div className="AskSupportDesc">
                      {app?.server_loc === 'EU'
                        ? t(
                            'Please submit a support request or call us at + 33 (1) 86 65 68 93',
                          )
                        : t(
                            'Please submit a support request or call us at + 1 (800) 570 – 0363',
                          ).replace(/570 – 0363/g, telnumber)}
                    </div>
                  </a>
                </div>
              )}
            </div>
          )}
        </div>

        <MessageBox
          visible={messageVisible}
          type={messageType}
          title={messageTitle}
          content={messageContent}
          onOk={onConfirmBoxOk}
          onCancel={onCancel}
          expire={true}
        />
        {/* <FirstLoginModal 
          show={showFirstLoginModal}
          onClose={handleCloseFirstLoginModal}
          onRegisterDevice={handleRegisterDeviceFromModal}
        /> */}
        {showScanner && (
          <QRCodeScanner
            show={showScanner}
            onClose={() => setShowScanner(false)}
            user={user}
            onRegisterSuccess={handleDeviceRegistered}
          />
        )}
      </DashboardLayout>

      <GPUDetectionModal show={showGPUModal} onClose={() => setShowGPUModal(false)} />
    </>
  );
};

export default DashboardContainer;
